import {Observable} from 'rxjs';
import {UserModel} from '../../models/user/user-model';

export abstract class StorageManagerGateway {
    abstract set(key: string, value: any): Observable<boolean>;
    abstract get(key: string): Observable<any>;
    abstract remove(key: string): Observable<boolean>;
    abstract getCurrentUser(): Observable<UserModel>;
    abstract setCurrentUser(userModel: UserModel): Observable<boolean>;
    abstract removeCurrentUser(): Observable<boolean>;
    abstract setBusinessViewMode(): Observable<boolean>;
    abstract unsetBusinessViewMode(): Observable<boolean>;
    abstract getBusinessViewMode(): Observable<boolean>;
    abstract clear(): Observable<boolean>;
}
